import React from 'react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-4 py-10">
      <div className="max-w-3xl mx-auto space-y-8">

        <div className="text-center">
          <h2 className="text-3xl font-bold text-purple-400 mb-3 text-center">Refund Policy</h2>
          <p className="text-lg text-gray-600">
            We value your satisfaction. This refund policy outlines the conditions under which refunds are applicable.
          </p>
        </div>

        <div className="space-y-8">
          <section>
            <h3 className="text-xl font-semibold mb-2 text-purple-400 text-center">1. General Refund Terms</h3>
            <p>
              All purchases made on Million2Trillion are considered final unless stated otherwise.
              However, we offer refunds under specific conditions mentioned below.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-2 text-purple-400 text-center">2. Refund Eligibility</h3>
            <ul className="list-disc list-inside pl-4 space-y-2">
              <li>If you were charged twice for the same service.</li>
              <li>If there was a technical failure from our end preventing access.</li>
              <li>If a product or service was misrepresented on the platform.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-2 text-purple-400 text-center">3. Non-Refundable Cases</h3>
            <ul className="list-disc list-inside pl-4 space-y-2">
              <li>Change of mind after purchase.</li>
              <li>Downloaded or consumed digital products or content.</li>
              <li>Late refund requests beyond 7 days from transaction.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-2 text-purple-400 text-center">4. How to Request a Refund</h3>
            <p>
              To initiate a refund, email{' '}
              <span className="font-semibold text-blue-800">support@million2trillion.com</span>
              {' '}with your order ID and reason. Our support team will verify and respond within 3–5 business days.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-2 text-purple-400 text-center">5. Payment Gateway Terms</h3>
            <p>
              Refunds will be processed to your original payment method. Processing charges may apply as per the provider’s policy.
            </p>
          </section>
        </div>

        <p className="text-sm text-center text-gray-500 italic mt-10">
          Last updated: June 2025
        </p>
      </div>
    </div>
  );
}
